import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { FieldExpression, NodeExpression, term, toString as luceneToString } from 'lucene';

import { PaginatedResult } from '../models/paginated-result';
import { ORDER_SERVER_URL } from '../../config';
import { OrderBy } from '../utils/constant';

const GET_BATCHES_URL = `${ ORDER_SERVER_URL }/v3/batches`;

export interface BatchContentWidget {
	customerArticleReference?: string;
	steelgrade?: string;
	steelgradeDescription?: string;
}

export type FieldOfBatchContentWidget = keyof BatchContentWidget;

@Injectable({ providedIn: 'root' })
export class BatchesService {
	constructor(
		private readonly http: HttpClient
	) {}

	getBatchesWidgetContent(
		fields: readonly FieldOfBatchContentWidget[],
		filter: string | undefined,
		index: number,
		limit: number,
		orderBy: OrderBy<keyof BatchContentWidget>[] | OrderBy<keyof BatchContentWidget>,
		onlyDistinct: boolean
	) {
		const url = new URL(GET_BATCHES_URL);
		const params = url.searchParams;
		params.append('fields', fields.join(','));
		if (filter) {
			params.append('filter', filter);
		}
		params.append('page', String(Math.floor(index / limit) + 1));
		params.append('limit', String(limit));

		params.append('orderBy', Array.isArray(orderBy) ? orderBy.join(',') : String(orderBy));

		params.append('distinct', String(onlyDistinct));

		return this.http.get<PaginatedResult<BatchContentWidget>>(url.toString());
	}

	createLuceneFilter(textSearch: string) {
		const search = `*${ term.escape(textSearch) }*`;

		const customerArticleReferenceField: FieldExpression = {
			field: 'customerArticleReference',
			term: search,
			quoted: false,
		};
		const steelgradeField: FieldExpression = {
			field: 'steelgradeDescription',
			term: search,
			quoted: false
		};

		const steelgradeCustomerNode: NodeExpression = {
			left: steelgradeField,
			operator: 'OR',
			parenthesized: false,
			right: customerArticleReferenceField
		};

		return luceneToString(steelgradeCustomerNode);
	}
}
